var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMute1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.42 2.09c.35.16.57.51.57.9v4h-2V5.13L11.5 8.89c-.19.15-.41.23-.65.23H6.97v5.85h1v2h-2c-.56 0-1-.45-1-1V8.11c0-.56.44-1 1-1h4.51l5.84-4.91c.29-.25.71-.31 1.06-.15Zm-1.43 16.76v-8.36h2v10.5c0 .38-.23.74-.58.9 -.36.16-.77.1-1.07-.15l-6.125-5.15 1.28-1.54 4.48 3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.29 20.29l18-18L21.7 3.7l-18 18 -1.42-1.42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute1);
export default __webpack_public_path__ + "static/media/mute 1.91a9b130d20bc49d04646fca934efb55.svg";
export { ForwardRef as ReactComponent };